import { render } from "./002-CeramsiteFactoryPage.vue?vue&type=template&id=15704cae&scoped=true"
import script from "./002-CeramsiteFactoryPage.vue?vue&type=script&lang=js"
export * from "./002-CeramsiteFactoryPage.vue?vue&type=script&lang=js"

import "@/assets/css/news.css?vue&type=style&index=0&id=15704cae&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15704cae"]])

export default __exports__